import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useWebhookCache } from './cache'
import { toResponseError, type WebhookData, type WebhookUpdateInput, type WebhookUpdateSuccess } from '@terros/common'

export function useUpdateWebhook(): UpdateHookResponse<WebhookData, WebhookData> {
  const mutation = useTantalimMutation<WebhookUpdateInput, WebhookUpdateSuccess>({
    url: '/webhook/update',
  })
  const cache = useWebhookCache()

  async function update(unsaved: WebhookData): Promise<WebhookData> {
    try {
      const { webhook } = await mutation.mutateAsync({ webhook: unsaved })
      cache.replaceItem(webhook)
      return webhook
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
